// extracted by mini-css-extract-plugin
module.exports = {"footer":"qP-Bo","link":"_1GaFR"};